import { css } from 'styled-components';

export const listingRichTextStyles = css`
  > :first-child {
    margin-top: 0;
  }

  h2 {
    margin-top: 40px;
    margin-bottom: 32px;
    font-size: 26px;
    line-height: 1.25;
  }
`;
